import { columnSorting } from 'assets/Icons'
import { Icon } from 'assets/index'
import { useState, Dispatch, SetStateAction, useEffect } from 'react'
import { Header, TableContent, Footer, Table } from './style'

interface TableRowData {
  [key: string]: any
}

interface IGridProps {
  pageData: TableRowData[]
  header: string[]
  width?: number
  filterData: TableRowData[]
  page: number
  setPage: Dispatch<SetStateAction<number>>
  columnsWidths?: number[]
  columnGap?: number
}

interface IGridItem {
  children: any
}

function HeaderItem(props: IGridItem) {
  const { children } = props
  return (
    <button
      type="button"
      onClick={() => console.log('data')}
      className="grid-header"
    >
      <span>{children}</span>
      <img className="btn-next-icon" src={columnSorting} alt="column sorting" />
    </button>
  )
} // Renderiza os itens do header da tabela

export default function DataGridDemo(props: IGridProps) {
  const {
    pageData,
    header,
    width,
    filterData,
    page,
    setPage,
    columnsWidths,
    columnGap,
  } = props
  const [firstItemPage, setFirstItemPage] = useState<number>(0)
  // Retirei a prop isFixed pois nao estava sendo utilizada

  const advanceTablePage = () => {
    if (page === Math.ceil(filterData.length / 10)) return

    setPage((oldValue) => oldValue + 1)
  }

  const backTablePage = () => {
    if (page === 1) return

    setPage((oldValue) => oldValue - 1)
  }

  useEffect(() => {
    setFirstItemPage(page * 10 - 10)
  }, [filterData, page])
  // Seta o primeiro item do counter da pagina

  if (!filterData.length) return null

  const lastItemPage = Math.min(
    firstItemPage + pageData.length,
    filterData.length
  )

  return (
    <Table>
      <Header
        columnNumber={header.length}
        width={width}
        columnsWidths={columnsWidths}
        columnGap={columnGap}
      >
        {header.map((title) => (
          <HeaderItem>{title}</HeaderItem>
        ))}
      </Header>

      <TableContent
        className="table-content"
        columnNumber={header.length}
        width={width}
        columnsWidths={columnsWidths}
        columnGap={columnGap}
      >
        {pageData.map((item: any) => item || <div>-</div>)}
        {/* Retirei a prop isFixed pois nao estava sendo utilizada 
         {!isFixed && data.map((item: any) => item || <div>-</div>)} */}
      </TableContent>

      <Footer>
        <div className="counter" data-testid={`itens-counter`}>
          {`${firstItemPage + 1}-${lastItemPage} de ${filterData.length}`}
        </div>

        <div className="right-container">
          <div data-testid={`page-counter`}>{`Página ${page}`}</div>
          <div className="pagination-container">
            <img
              className="table-chevron"
              src={Icon('chevron_left.svg')}
              alt="back table page"
              onClick={backTablePage}
              data-testid={`page-back-btn`}
            />
            <span data-testid={`page-min-max-counter`}>{`${page}/${Math.ceil(
              filterData.length / 10
            )}`}</span>
            <img
              className="table-chevron"
              src={Icon('chevron_right.svg')}
              alt="advance table page"
              onClick={advanceTablePage}
              data-testid={`page-advance-btn`}
            />
          </div>
        </div>
      </Footer>
    </Table>
  )
}
